/* unplugin-vue-components disabled */import script from "./ModifyPsd.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModifyPsd.vue?vue&type=script&setup=true&lang=ts"

import "./ModifyPsd.vue?vue&type=style&index=0&id=47fcf6bf&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fcf6bf"]])

export default __exports__